import { IAction } from '../../../interface/action/action.interface';
import { IRedirectPagePayload } from '../../../interface/action/browser-action.interface';
import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';

export const replacePage = (uri: string): IAction<IRedirectPagePayload> =>
  returnAction(ActionEnum.REPLACE_PAGE, {uri}, true);
